export default __webpack_public_path__ + "static/media/medium_white.dd67016c.svg";